import { AccessesToModelsDto } from "../../@shared/Models/AccessModels";
import { User } from "../../@shared/Models/Models";

const initialAccessControlModel = {
    openedAccessModelId: "" as string,
    isShowAccessModal: false as boolean,
    isShowLoader: false as boolean,
    list: [] as AccessesToModelsDto[],
    searchedUsers: [] as User[]
}

export const initialState = {
    accessControlModel: initialAccessControlModel,
}

export type AccessControlStateType = typeof initialState;